var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gs-app gs-final-affiliate-tracking"},[_c('tracking')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }